<template>
    <div class="content-container topicresult">
        <div class="header">
            <div class="header-left title"></div>
            <div class="header-right pagination">
                <Paginator v-if="pageReady" :pageData="pageData" />
            </div>
        </div>
        <!-- <div class="subtitle orderbar">
            <div class="col-order">Order: Last Post <img class="chevron" src="/icons/icon_down-arrow.png"/></div>
            <div class="col-alpha">Z - A <img class="chevron" src="/icons/icon_down-arrow.png"/></div>
            <div class="col-show">Show All <img class="chevron" src="/icons/icon_down-arrow.png"/></div>
            <div class="col-topics">Topics <img class="chevron" src="/icons/icon_down-arrow.png"/></div>
            <div class="col-actions">Mark all as read and return</div>
        </div> -->
        <div class="blocklist-header subtitle columntitles">
            <div class="col-status center"><p class="text">Status</p></div>
            <div class="smalltop">
                <div class="col-topic">Topic Title</div>
                <div class="col-board">Board</div>
                <div class="col-starter center">Started By</div>
            </div>
            <div class="smallbot">
                <div class="col-replies center">Content</div>
            </div>                
        </div>
        <div class="content nopad">                
            <PostResultItem v-for="post in advancedSearchPosts" :key="post.id" :post="post"></PostResultItem>                
        </div>
        <div class="footer">
            <div class="footer-right pagination">
                <Paginator v-if="pageReady" :pageData="pageData" />
            </div>            
        </div>
    </div>
    <!-- <div>
        <ul>
            <TopicResultItem v-for="topic in topics" :key="topic.id" :topic="topic"></TopicResultItem>
        </ul>
    </div> -->
</template>

<script>
    import Paginator from '../../components/Widgets/Paginator.vue'
    import PostResultItem from '../../components/Posts/PostResultItem.vue'
    // import settings from '../../modules/settings'
    import api from '../../api/api'
    // import common from '../../modules/common'

    /*
    topicListType:
        active
        mydiscussions
        unanswered
        new
    */

    export default {

        props: ['postListType'],

        data() {
            return {
                pageReady: false,
                pageData: {
                    currentPage: 1,
                    pageSize: 20,
                    totalItems: null,
                    getPage: this.getPage,
                }
            }
        },
        components: { 
            Paginator,
            PostResultItem
        },
        methods: {
            loadPage: function() {
                this.getPage(1);
            },
            getPage(pageNumber) {
                if( this.postListType == 'search') {
              if (this.isAdvancedSearch) {
                api.get('/search/advancedPostResults', {
                    params: {
                        SearchID: this.$store.state.topic.currentPostSearchId,
                        pageSize: this.pageData.pageSize,
                        requestedPage: pageNumber,
                        sortOrder: 'asc'
                    }
                }).then((r) => {
                    this.$store.commit('setAdvancedSearchedPosts', r.data);
                    if(r.data.length > 0) {
                        this.pageData.totalItems = r.data[0].totalRows;
                        this.pageReady = true;
                    }
                })
              }
                 }
                 this.pageData.currentPage = pageNumber;
            },
        },
        computed: {
            advancedSearchPosts() {
                return [...this.$store.state.topic.advancedSearchPosts];
            },
            isAdvancedSearch: function () {
              return this.$store.state.topic.currentPostSearchId != null;
            },
        },
        watch: {
          searchedTopics (newSearched) {
            if(this.postListType === 'search') {
              this.topics = newSearched;
              this.pageData.totalItems = this.topics.length;
            }
          },
          isAdvancedSearch (newValue) {
              if (newValue) {
                  this.loadPage();
              }
          }
        },

        beforeRouteUpdate(to, from, next) {
            // handle same-page/different-param route
            this.postListType = to.params.postListType;
            this.loadPage();
            next()            
        },
        mounted() {
            this.loadPage();
        },
        beforeDestroy() {
            this.$store.commit('setSearchedIdPosts', null);
        }
    }

</script>

<style scoped>
.col-topic{
    width:6%;
}
</style>